import React, { useState } from "react";
import { Badge, Form, Modal, Spinner } from "react-bootstrap";

const UpdateQueryCustomValueModal = ({
  Show,
  Hide,
  setCustomValue,
  customValue,
  setCustomType,
  customType,
  setQuery,
  queryId,
  setQueryId,
  query,
}) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const updateQueryCustomVValue = (customType, customValue) => {
    setButtonLoader(true);
    const updatedQuery = query?.map(item => {
      if (item.id === queryId) {
        return {
          ...item,
          valueType: customType,
          value: customValue || ""
        };
      }
      return item;
    });
    setQuery(updatedQuery);
    setCustomValue("")
    setQueryId("")
    Hide()
    setButtonLoader(false);
  };
  return (
    <>
      <Modal show={Show} onHide={Hide} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            Replace Custom Value
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Value Type{" "}
              <abbr title="required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => {setCustomType(e.target.value); setCustomValue("SCREENINGDATE")}}
              className="br3"
              style={{ fontSize: 12 }}
            >
              <option selected={customType === ""} value="">Select Type</option>
              <option selected={customType === "text"} value="text">Text</option>
              <option selected={customType === "number"} value="number">Number</option>
              <option selected={customType === "date"} value="date">Date</option>
              <option selected={customType === "time"} value="time">Time</option>
              <option selected={customType === "subjectScreeningDate"} value="subjectScreeningDate">Subject Screening Date</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Custom Value{" "}
              <abbr title="required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCustomValue(e.target.value)}
              value={customValue}
              className="br3"
              placeholder="Custom Value"
              disabled={customType === "subjectScreeningDate" ? true : !customType}
              type={customType}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="p-1 px-3 bg-light">
          <button
            className="updateProfile"
            style={{ fontSize: 12 }}
            disabled={!customValue || !customType}
            onClick={() => updateQueryCustomVValue(customType, customValue)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Replacing...
              </div>
            ) : (
              "Replace"
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateQueryCustomValueModal;
